import { safeParseInt } from '../helpers/parsers';
import React from 'react';
import { useQuery } from './useQuery';
import { ITEMS_PER_PAGE_OPTIONS } from '../constants/paging';
import { PagingURLQuery } from '../types/URLQuery';
const pageFn = (data, currentPageIndex, itemsPerPage) => {
    let pagedData = [...data];
    if (itemsPerPage > 0) {
        const start = itemsPerPage * currentPageIndex;
        const end = start + itemsPerPage;
        pagedData = pagedData.slice(start, Math.min(end, data.length));
    }
    return pagedData;
};
const checkPageIndexInRange = (currentPageIndex, itemsPerPage, dataLength) => {
    const start = itemsPerPage * currentPageIndex;
    return start >= dataLength ? null : currentPageIndex;
};
const checkValidItemsPerPage = (itemsPerPage, pageSizeOptions) => {
    return pageSizeOptions.find(option => option === itemsPerPage) || pageSizeOptions[0];
};
export const createInitialPageState = (defaultOverride) => {
    return Object.assign(Object.assign({}, defaultOverride), { pageSizeOptions: (defaultOverride && defaultOverride.pageSizeOptions) || ITEMS_PER_PAGE_OPTIONS, currentPageIndex: (defaultOverride && defaultOverride.currentPageIndex) || 0, data: (defaultOverride && defaultOverride.data) || [], pageFn: (defaultOverride && defaultOverride.pageFn) || pageFn });
};
const createReducer = () => (state, action) => {
    switch (action.type) {
        case 'PAGE':
            if (action.currentPageIndex) {
                return Object.assign(Object.assign({}, state), { currentPageIndex: action.currentPageIndex, data: action.data || state.data });
            }
            switch (action.direction) {
                case 'prev':
                    return Object.assign(Object.assign({}, state), { currentPageIndex: state.currentPageIndex - 1, data: action.data || state.data });
                case 'next':
                    return Object.assign(Object.assign({}, state), { currentPageIndex: state.currentPageIndex + 1, data: action.data || state.data });
                default:
                    return Object.assign(Object.assign({}, state), { currentPageIndex: state.currentPageIndex, data: action.data || state.data });
            }
        case 'SET_ITEMS_PER_PAGE':
            return Object.assign(Object.assign({}, state), { itemsPerPage: action.itemsPerPage, currentPageIndex: 0 });
        case 'RESET_PAGING':
            return Object.assign(Object.assign({}, state), { currentPageIndex: 0 });
        default:
            throw new Error('Page action type not valid.');
    }
};
export const usePaging = (initialState) => {
    var _a;
    // state from query params
    const query = useQuery();
    const [queryParams, setQueryParams] = React.useState({
        pageSize: safeParseInt(query.get(PagingURLQuery.pageSize)),
        currentPage: safeParseInt(query.get(PagingURLQuery.currentPage)),
    });
    const [pagedData, setPagedData] = React.useState([]);
    const [pageState, dispatch] = React.useReducer(createReducer(), createInitialPageState(Object.assign(Object.assign({}, initialState), { itemsPerPage: initialState.pageSizeOptions && initialState.pageSizeOptions.length > 0
            ? checkValidItemsPerPage(queryParams.pageSize || initialState.itemsPerPage || 0, initialState.pageSizeOptions)
            : ITEMS_PER_PAGE_OPTIONS[0], currentPageIndex: (queryParams.currentPage &&
            queryParams.pageSize &&
            checkPageIndexInRange(queryParams.currentPage, queryParams.pageSize, ((_a = initialState.data) === null || _a === void 0 ? void 0 : _a.length) || 0)) ||
            initialState.currentPageIndex })));
    React.useEffect(() => {
        if (queryParams.pageSize)
            query.set(PagingURLQuery.pageSize, queryParams.pageSize.toString());
        if (queryParams.currentPage)
            query.set(PagingURLQuery.currentPage, queryParams.currentPage.toString());
    }, [queryParams]);
    React.useEffect(() => {
        if (pageState.itemsPerPage && pageState.itemsPerPage > 0)
            setQueryParams(Object.assign(Object.assign({}, queryParams), { pageSize: pageState.itemsPerPage }));
        if (pageState.currentPageIndex)
            setQueryParams(Object.assign(Object.assign({}, queryParams), { currentPage: pageState.currentPageIndex }));
        setPagedData(pageState.pageFn(pageState.data, pageState.currentPageIndex, pageState.itemsPerPage || 0));
    }, [setPagedData, pageState]);
    return {
        pagedData: pagedData,
        pageState: pageState,
        pageDispatch: dispatch,
    };
};
